/* tslint:disable */
/* eslint-disable */
/**
 * Main data new API
 * Auto-generated openapi scheme for main-data-new API
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MonitoredObjectGroupReplaceAssets
 */
export interface MonitoredObjectGroupReplaceAssets {
    /**
     * 
     * @type {Array<number>}
     * @memberof MonitoredObjectGroupReplaceAssets
     */
    monitoredObjects: Array<number>;
    /**
     * 
     * @type {Array<number>}
     * @memberof MonitoredObjectGroupReplaceAssets
     */
    monitoredObjectGroups: Array<number>;
}

export function MonitoredObjectGroupReplaceAssetsFromJSON(json: any): MonitoredObjectGroupReplaceAssets {
    return MonitoredObjectGroupReplaceAssetsFromJSONTyped(json, false);
}

export function MonitoredObjectGroupReplaceAssetsFromJSONTyped(json: any, ignoreDiscriminator: boolean): MonitoredObjectGroupReplaceAssets {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'monitoredObjects': json['monitored_objects'],
        'monitoredObjectGroups': json['monitored_object_groups'],
    };
}

export function MonitoredObjectGroupReplaceAssetsToJSON(value?: MonitoredObjectGroupReplaceAssets | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'monitored_objects': value.monitoredObjects,
        'monitored_object_groups': value.monitoredObjectGroups,
    };
}


